/**
     * @desc 获取音视频配置项
仅会产生统一错误码
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** 配置项key，不传则查询所有配置项，多个配置项值通过逗号分隔 */
  key?: string;
}

export const method = 'GET';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/web/v3/setting', params, 'GET'),
    newValue,
    shouldRevalidate,
  );
}

export function useRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/web/v3/setting',
    params,
    swrOptions,
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/web/v3/setting', params, 'GET'),
    {
      method: 'GET',

      ...options,
    },
  );
}
